import axios from "axios";
import Cookies from "universal-cookie";

export const useFetch = () => {
  const BASE_URL = process.env.REACT_APP_SERVIDOR;
  const cookies = new Cookies();
  const ACCESS_TOKEN = cookies.get(
    "perv_v2_cookies_user_kdfoeinapjdkfawep"
  );
  const USERNAME = cookies.get("nombre_user");
  const PERFIL = cookies.get("perfil");

  const fetchData = async ({
    url,
    method = "get",
    body,
    permission,
    contentType = "application/json",
    responseType = "json",
  }) => {
    try {
      const isFormData =
        typeof FormData !== "undefined" && body instanceof FormData;

      const headers = {
        Authorization: `Bearer ${ACCESS_TOKEN}`,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        nombre_usuario: USERNAME,
        tipo_perfil: PERFIL,
      };

      // Si es FormData, no forzar Content-Type: axios pone el boundary.
      if (!isFormData) {
        headers["Content-Type"] = contentType;
      }

      const config = {
        url: `${BASE_URL}${url}`,
        method,
        data: body,
        responseType,
        headers,
      };

      if (permission) {
        config.headers.Permission = permission;
      }

      const response = await axios(config);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return fetchData;
};
